<div class="form-item" [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
    <div>
      <strong>{{fieldSubmission.field.label}}</strong>
      <span class="form-ast" [hidden]="!fieldSubmission.field.mandatory"> * </span>
    </div>
  </div>
    <div class="field-selector-fill"  [ngClass]="{'invalid-field': !valid && fieldSubmission.field.mandatory }">
      <core-helpers-forms-key-select
        [options]="items"
        [placeholder]="placeholder"
        (actionSelectItem)="onSelect($event)"
      ></core-helpers-forms-key-select>
    </div>

</div>